import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../theme";
import GetEBookButton from "./GetEBookButton";

export default function WhyNowSection() {
  return (
    <ThemeProvider theme={theme}>
      <Box
        component="section"
        sx={{
          py: { xs: 4, md: 10 },
          bgcolor: "custom.blue",
        }}
      >
        <Container maxWidth="md" sx={{ px: { xs: 1, sm: 2, md: 0 } }}>
          <Grid
            container
            spacing={{ xs: 2, md: 4 }}
            justifyContent="center"
            textAlign={{ xs: "left", md: "center" }}
          >
            {/* Headline */}
            <Grid item xs={12}>
              <Typography
                component="h3"
                sx={{
                  fontSize: { xs: "1.3rem", sm: "1.6rem", md: "32px" },
                  fontWeight: 400,
                  color: "rgba(28, 30, 46, 1)",
                  mb: { xs: 1, md: 2 },
                  textAlign: { xs: "left", md: "center" },
                }}
              >
                <strong>But Why Does This Matter Now?</strong>
              </Typography>
            </Grid>

            {/* Main text block */}
            <Grid item xs={12} md={9}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: "15px", sm: "16px", md: "20px" },
                  color: "#000",
                  lineHeight: 1.5,
                }}
                paragraph
              >
                Because these patterns don’t just “pass” with time. They grow deeper. And so does the distance. With just a few pages a day, you can start shifting your family’s energy from surviving to truly connecting.
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: "15px", sm: "16px", md: "20px" },
                  fontWeight: 700,
                  color: "#000",
                }}
                paragraph
              >
                <em>Don’t wait for things to “get better on their own.”</em>
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: "15px", sm: "16px", md: "20px" },
                  color: "#000",
                }}
                paragraph
              >
                They won’t.
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: "15px", sm: "16px", md: "20px" },
                  color: "#000",
                }}
                paragraph
              >
                But they can, if you start today.
              </Typography>
            </Grid>

            {/* Oxford study block */}
            <Grid item xs={12} md={9}>
              <Typography
                sx={{
                  fontSize: { xs: "15px", sm: "16px", md: "20px" },
                  color: "#000",
                  lineHeight: 1.5,
                }}
              >
                <strong>A major Oxford University-led study of over 480 children found that</strong> those who experienced warm, responsive parenting were far more likely to <strong>BOUNCE BACK</strong> from stress, not just emotionally, but even in how their brains developed.
              </Typography>
            </Grid>

            {/* Closing statement */}
            <Grid item xs={12} md={9}>
              <Typography
                sx={{
                  fontSize: { xs: "15px", sm: "16px", md: "20px" },
                  fontWeight: 700,
                  color: "#000",
                  mt: { xs: 1, md: 2 },
                }}
              >
                That’s exactly what <em>Happy US</em> helps you build:
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: "15px", sm: "16px", md: "20px" },
                  color: "#000",
                }}
              >
                the simple tools, rituals, and connections that nurture that same warmth and resilience in your child.
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} sx={{ py: { xs: 1, md: 2 } }}>
              <Box sx={{ display: "flex", justifyContent: { xs: "flex-start", md: "center" } }}>
                <GetEBookButton />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
